<template>
  <div class="other-wrapper">
   <h1 class="main-title individual grid-container">Other</h1>
   <div class="layer2">
    <div class="grid-container grid-100" v-for="item in items" :key="item.id">
      <div class="grid-100 ondemand-main"  v-bind:style="{ backgroundImage: `url('${item.image.guid}')`}" > 
        <div data-v-966b223c="" class="other-copy white">
          <h4 data-v-966b223c="" class="title">{{ item.title.rendered }}</h4><p>{{ item.sub_title }}</p>
          <p>&nbsp;</p>
        </div>
        
      </div>

      <div class="grid-100 other-img-mobile" > 
        <img src="https://tools.mercedes-benz.co.uk/current/utilities/rn/other.jpg" />
      </div>
      <div data-v-966b223c="" class="other-copy-mobile black">
        <h4 data-v-966b223c="" class="title">{{ item.title.rendered }}</h4> <p>{{ item.sub_title }}</p>
        <p>&nbsp;</p>
      </div>

      <div class="grid-100 grid-parent">
        <div class="video-item grid-100 grid-parent">
          <div class="video-header grid-100 grid-parent">
            <div class="video">
              <iframe id="main-video" width="560" height="315" :src="item.video_id_url" frameborder="0" allowfullscreen></iframe>
            </div>
          </div>
        </div>
      </div>
        
      </div>
    </div>
  </div>
</template>

<script>
import { apiRequest } from "../services";

export default {
    name: "test",
    // This data will be used when the CMS has no content. Can be deleted once the
    // new CMS has been filled with content
    originalData: [
      {
        id: 0,
        title: {
          rendered: "Ross in Young Frankenstein",
        },
        image: {
          guid: "https://tools.mercedes-benz.co.uk/current/utilities/rn/other.jpg",
        },
        sub_title: "From the brains behind The Producers, Blazing Saddles and Spaceballs. Legendary filmmaker and comedian Mel Brooks brings his musical comedy Young Frankenstein to life on stage in an all-singing, all-dancing musical collaboration with Tony-award winning Broadway director and choreographer Susan Stroman.",
        video_id_url: "https://www.youtube.com/watch?v=84_6aqBXP04",
      },
    ],
    data() {
        return {
            items: [],
        };
    },
    mounted() {
      window.scrollTo(0, 0);

      apiRequest("others-page")
        .then(this.init.bind(this))
        .catch(this.failed);
    },
    methods: {
      init(data) {
        if (!data || data && data.length === 0) {
          this.items = this.$options.originalData;
        } else {
          this.items = data;
        }
      },
      autoplay() {
        if (this.$route.params.autoplay) {
            setTimeout(function() {
                window.scrollTo(
                    0,
                    document
                        .getElementById("main-video")
                        .getBoundingClientRect().top
                );
                document.getElementById("main-video").src += "&autoplay=1";
            }, 100);
        }
      },
      failed(error) {
        console.warn(error);
      },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
    font-weight: normal;
}

ul {
    list-style-type: none;
    padding: 0;
}

li {
    display: inline-block;
    margin: 0 10px;
}

a {
    color: #42b983;
}
</style>



// WEBPACK FOOTER //
// Other.vue?3b6c5e55